import { User } from 'src/interfaces/entities/user';

const roleHierarchy = {
	user: 1,
	admin: 2,
	partner: 3,
	super_admin: 4,
};

export const checkRole = (
	role: 'user' | 'admin' | 'super_admin' | 'partner',
	options: {
		user: User | null,
	}
): boolean | undefined => {
	const { user, } = options;
	if (!user) return undefined;
	
	return roleHierarchy[user.role] >= roleHierarchy[role];
};